export default __webpack_public_path__ + "static/media/meta-mask.2a04fb37.png";